import { useLayoutEffect, useState } from 'react';

const RESIZE_DEBOUNCE_MS = 100;

/**
 * Sets --mmc-h to component's measured height for use by mh() helper. Also returns the height
 * so children can list it as an effect dependency — child effects run before parent ones,
 * so they'd measure against the 100vh fallback without this re-trigger.
 */
export function useContainerHeightVar(ref) {
  const [heightPx, setHeightPx] = useState(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;

    const applyHeight = () => {
      // Skip writes at 0 height (hidden ancestor) so --mmc-h keeps its last value.
      const { height } = el.getBoundingClientRect();
      if (height > 0) {
        el.style.setProperty('--mmc-h', `${height}px`);
        setHeightPx(height);
      }
    };
    applyHeight();

    let debounceTimer = null;
    const observer = new ResizeObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyHeight, RESIZE_DEBOUNCE_MS);
    });
    observer.observe(el);

    return () => {
      clearTimeout(debounceTimer);
      observer.disconnect();
    };
  }, [ref]);

  return heightPx;
}
